import { useState } from 'react'
import './AIToolbar.css'

export function AIToolbar({ onGenerate, isGenerating }) {
  const [prompt, setPrompt] = useState('')
  const [apiEndpoint, setApiEndpoint] = useState('https://api.openai.com/v1/images/generations')
  const [apiKey, setApiKey] = useState('')
  const [showSettings, setShowSettings] = useState(false)

  const handleGenerate = () => {
    if (!prompt.trim()) {
      alert('请输入生图提示词')
      return
    }
    
    if (!apiKey.trim()) {
      alert('请先配置API Key')
      return
    }

    onGenerate({
      prompt: prompt.trim(),
      apiEndpoint,
      apiKey
    })
  }

  return (
    <div className="ai-toolbar">
      <div className="toolbar-main">
        <h1 className="toolbar-title">🎨 无限画布 AI生图</h1>
        
        <div className="toolbar-controls">
          <input
            type="text"
            className="prompt-input"
            placeholder="输入AI生图提示词..."
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleGenerate()}
            disabled={isGenerating}
          />
          
          <button
            className="generate-btn"
            onClick={handleGenerate}
            disabled={isGenerating || !prompt.trim()}
          >
            {isGenerating ? '生成中...' : '生成图片'}
          </button>
          
          <button
            className="settings-btn"
            onClick={() => setShowSettings(!showSettings)}
          >
            ⚙️ 设置
          </button>
        </div>
      </div>

      {showSettings && (
        <div className="toolbar-settings">
          <div className="setting-group">
            <label>API端点：</label>
            <input
              type="text"
              value={apiEndpoint}
              onChange={(e) => setApiEndpoint(e.target.value)}
              placeholder="https://api.openai.com/v1/images/generations"
            />
          </div>
          
          <div className="setting-group">
            <label>API Key：</label>
            <input
              type="password"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              placeholder="输入你的API密钥"
            />
          </div>
          
          <div className="setting-info">
            <p>💡 支持任何兼容OpenAI格式的API</p>
            <p>• OpenAI DALL-E</p>
            <p>• Stability AI</p>
            <p>• 自定义API端点</p>
          </div>
        </div>
      )}
    </div>
  )
}
